import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { useAuth } from "../../../context/AuthContext";
import { useProtectedRoute } from "../../../hooks/useProtectedRoute";
import SupplierForm from "../components/SupplierForm"; // <-- import the component

const AddSupplierPage: React.FC = () => {
  useProtectedRoute();
  const { token } = useAuth();
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);

  // This function will be passed to SupplierForm
  const handleSubmit = async (form: any) => {
    setSaving(true);
    try {
      await api.post("/inventory/suppliers", form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      navigate("/suppliers");
    } catch (err: any) {
      alert(err.response?.data?.message || "Could not add supplier");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto p-4">
      <h1 className="text-2xl font-bold mb-6">Add Supplier</h1>
      <div className="bg-white p-6 rounded shadow">
        <SupplierForm onSubmit={handleSubmit} saving={saving} />
      </div>
    </div>
  );
};

export default AddSupplierPage;
